import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Field } from 'formik';

import { interpolate } from 'utilities/interpolate';

import styles from './pin4.module.scss';

const Pin4Input = (props) => {
  const { error, touched, name, label } = props;
  const showError = error && touched;

  return (
    <div
      className={classnames(styles.inputDetails, {
        [styles.hasError]: showError,
      })}
    >
      <label className={styles.label} htmlFor={name}>
        {label}
      </label>

      <div className={styles.inputWrapper}>
        <div className={styles.inputPrepend}>0</div>

        <Field
          type="tel"
          id={name}
          name={name}
          placeholder="7890123456"
          data-test-id={`pin4-number-input-${name}`}
          className={classnames(styles.input, {
            [styles.inputError]: showError,
          })}
          onCopy={(e) => {
            e.preventDefault();
            return false;
          }}
        />
      </div>

      {showError ? (
        <div className={classnames(styles.inputValidationErrorText)}>
          {interpolate(error, '[br]', <br key={null} />)}
        </div>
      ) : null}
    </div>
  );
};

Pin4Input.propTypes = {
  error: PropTypes.string,
  touched: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
};

export default Pin4Input;
